/**
 * Theme mode utilities for dark mode toggle
 */

export const THEME_MODE_KEY = 'myutilities-theme-mode';

export type ThemeMode = 'light' | 'dark' | 'system';

/**
 * Gets the saved theme mode from localStorage
 */
export const getSavedThemeMode = (): ThemeMode | null => {
  try {
    const saved = localStorage.getItem(THEME_MODE_KEY);
    if (saved === 'light' || saved === 'dark' || saved === 'system') {
      return saved;
    }
    return null;
  } catch {
    return null;
  }
};

/**
 * Saves the theme mode preference to localStorage
 */
export const saveThemeMode = (mode: ThemeMode): void => {
  try {
    localStorage.setItem(THEME_MODE_KEY, mode);
  } catch {
    // Silent fail for localStorage issues
  }
};

/**
 * Detects the system/OS preferred color scheme
 */
export const getSystemThemeMode = (): 'light' | 'dark' => {
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return 'light';
};

/**
 * Resolves the effective theme mode (light/dark)
 * based on saved preference or system preference
 */
export const resolveThemeMode = (): 'light' | 'dark' => {
  const saved = getSavedThemeMode();

  if (saved === 'system' || saved === null) {
    return getSystemThemeMode();
  }

  return saved;
};
